<toaster-container class="base-font-enforced" [toasterconfig]="toasterconfig">
</toaster-container>
